export const colors = {
  light: {
    //background colors
    bgPrimary: "#f4f5f6",
    bgSecondary:
      "linear-gradient(to right, hsl(210 79% 46% / 0.05), transparent)",
    bgTeritary: "rgb(226, 230, 233)",
    bgWhite: "#fff",
    filterBg: "rgba(241, 245, 249, 0.3)",
    lightRed: '#F79797',

    //button bg
    bgButtonlight: "rgb(240, 242, 244)",
    outlineButtonBg: "#F9FAFB",

    //input bg
    bgInputField: "rgb(249, 250, 251)",

    //border colors
    borderPrimary: "rgba(25, 117, 210, 0.1)",
    borderSecondary: "rgb(226, 230, 233)",
    borderTeritary: "rgb(225, 231, 239)",
    borderInputField: "rgba(108, 124, 147, 0.2)",
    borderLight: '#E0E3E7',

    //text colors
    textBlack: "rgb(29, 37, 48)",
    textWhite: "rgb(249, 250, 251)",
    textSecondary: "rgb(48, 61, 80)",
    textGrey: "rgb(108, 124, 147)",
    textGreen: "#268723",

    //table
    tableRowBg: "rgba(232, 235, 237, 0.3)",
    tableHeader: "rgb(108, 124, 147)",
    tableBorder: "rgba(224, 230, 235, 0.5)",
    tableBgHover: "#F4F7FB",
  },
  dark: {
    //background colors
    bgPrimary: "#131820",
    bgSecondary: "linear-gradient( to right, hsl(210 79% 55% / 0.05)",
    bgTeritary: "rgb(45, 54, 67)",
    bgWhite: "rgb(27, 34, 45)",
    filterBg: "rgba(29, 40, 58, 0.3)",
    lightRed: '#F79797',

    //button bg
    bgButtonlight: "rgba(41, 49, 61, 0.8)",
    outlineButtonBg: "rgba(25, 117, 210, 0.3)",

    //input bg
    bgInputField: "rgb(19, 24, 32)",

    //border colors
    borderPrimary: "rgb(45, 54, 67)",
    borderSecondary: "rgb(45, 54, 67)",
    borderTeritary: "rgb(29, 40, 58)",
    borderInputField: "rgba(138, 153, 168, 0.2)",
    borderLight: "rgba(255,255,255,0.12)",

    //text colors
    textBlack: "rgb(249, 250, 251)",
    textWhite: "rgb(29, 37, 48)",
    textGrey: "rgb(138, 153, 168)",
    textSecondary: "rgb(249, 250, 251)",
    textGreen: "#268723",

    //table
    tableRowBg: "rgba(37, 44, 55, 0.3)",
    tableHeader: "rgb(138, 153, 168)",
    tableBorder: "rgba(45, 54, 67, 0.5)",
    tableBgHover: "#1F2937",
  },
  primary: "rgba(25, 117, 210, 0.9)",
  primaryDark: "rgb(29, 78, 216)",
  primaryblue: 'rgb(25, 118, 210)',
  green: "#268723",
};
